import { useCallback, useEffect, useState } from "react";
import { useGetClients } from "../../interfaces/clients";
import CommonDataGrid from "../common/CommonDataGrid";
import { Autocomplete, Box, Button, Checkbox, ClickAwayListener, FormControl, FormControlLabel, Popper, Radio, RadioGroup, TextField } from "@mui/material";
import { useQueryClient } from "react-query";
import { CommonGridBox, CommonMainWrap, CommonModalWrap, CommonSubBox } from "../../styles/common";

import { formatBizNo } from "../../common/util";
import moment from "moment";
import { useGetProjectCodeList, useGetProjects, useSetProject, useSetProjectStatus } from "../../interfaces/project";
import { useNavigate } from "react-router-dom";
import ProjectStatusLabel from "../common/ProjectStatusLabel2";
import theme from "../../styles/theme";
import styled from "styled-components";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import CommonModalBar from "../common/CommonModalBar";

const StatusLabel = (props) => {
    return (
        <ProjectStatusLabel status={props.value.status} value={props.value.value} />
    )
}

const columns = [
    { field: 'pro_st_info', headerName: '과업상태', width: 70, headerAlign:'center', align:'center',renderCell:StatusLabel },
    { field: 'pno', headerName: '과업번호', width: 120, headerAlign:'center', align:'center' },
    { field: 'pnm', headerName: '과업명', width: 220, headerAlign:'center' },
    { field: 'cname', headerName: '업체명', width: 150, headerAlign:'center' },
    { field: 'reg_cd_nm', headerName: '지역', width: 110, headerAlign:'center', align:'center' },
    { field: 'pro_tp_nm', headerName: '유형', width: 100, headerAlign:'center', align:'center' },
    { field: 'pro_kd_nm', headerName: '용도', width: 100, headerAlign:'center', align:'center' },
    { field: 'sdate', headerName: '시작일', width: 100, headerAlign:'center', align:'center' },
    { field: 'edate', headerName: '종료일', width: 100, headerAlign:'center', align:'center' },
    { field: 'odate', headerName: '제출일', width: 100, headerAlign:'center', align:'center' },
    
]

const TitleLine = styled.li`
    list-style-type: none;
    width: 100%;
    // max-width: 100%;
    // overflow: auto;
    padding: 0;
    margin: 0;
    cursor: pointer;
    li {
        padding: 0;
        margin: 0;
        width: 100%;
        font-size: 1rem;
        line-height: 2rem;
        font-weight: bold;
        display: grid;
        gap: 0.4rem;
        grid-template-columns: 6.5rem minmax(15rem,25rem) 12rem 12rem 12rem 8rem minmax(10rem, auto);
        span {
            margin:auto;padding:0;
            text-align: center;
            height: 1.8rem;
            border-bottom: 1px solid ${theme.color.black[10]};
        }
        span:last-child {
            border:0;
        }
    }
    border-top: 2px solid ${theme.color.black[60]};
    border-bottom: 2px solid ${theme.color.black[60]};
`;

const ProjectList = styled.li`
    list-style-type: none;
    width: 100%;
    // max-width: 100%;
    // overflow: auto;
    padding: 0;
    margin: 0;
    cursor: pointer;
    min-height: 5rem;
    max-height: 43rem;
    overflow: auto;
    border-bottom: 2px solid ${theme.color.black[60]};
    li {
        width: 100%;
        font-size: 1rem;
        line-height: 2rem;
        // height: 2.2rem;
        display: grid;
        gap: 0.4rem;
        grid-template-columns: 6.5rem minmax(15rem,25rem) 12rem 12rem 12rem 8rem minmax(10rem, auto);
        border-bottom: 1px solid ${theme.color.black[20]};
        .box {
            padding: 0.5rem 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;;
            gap: 0.5rem;
        }
    }
    li:last-child {
        border: 0;
    }
`;

const Project = () => {

    const queryClient = useQueryClient();

    const [projectList, setProjectList] = useState([]);

    const [searchStatus, setSearchStatus] = useState();
    const [searchPnm, setSearchPnm] = useState();
    const [searchAlias, setSearchAlias] = useState();

    const [clientList, setClientList] = useState([]);
    const [proStList, setProStList] = useState([]);
    const [proKdList, setProKdList] = useState([]);
    const [proTpList, setProTpList] = useState([]);
    const [regionList, setRegionList] = useState([]);

    const [newModal, setNewModal] = useState(false);

    const {data: list, isLoading} = useGetProjects();
    const {data: cList} = useGetClients();
    const {data: codeList} = useGetProjectCodeList();

    useEffect(()=>{
        if(list){
            const statusFilter = searchStatus ? list.filter((item)=> (item.pro_st+'') === searchStatus) : list;
            const pnmFilter = searchPnm ? statusFilter.filter((item)=> item.pnm.indexOf(searchPnm) > -1) : statusFilter;
            const aliasFilter = searchAlias ? pnmFilter.filter((item)=> item.cname.indexOf(searchAlias) > -1) : pnmFilter;

            setProjectList(aliasFilter.map((item,index)=>({...item,id:index,pro_st_info:{status:item.pro_st,value:item.pro_st_nm}})));

        }else{
            setProjectList([])
        }
    },[list, searchStatus, searchPnm, searchAlias])
    
    useEffect(()=>{
        if(cList){
            setClientList(cList.map((item,index)=>({
                ...item,
                label:item.cname})
                ));
        }
    },[cList])

    useEffect(()=>{
        if(codeList){
            setProStList(codeList.pro_st.map((item,index)=>({
                ...item,
                label:item.value})
                ));
            setProKdList(codeList.pro_kd.map((item,index)=>({
                ...item,
                label:item.value})
                ));
            setProTpList(codeList.pro_tp.map((item,index)=>({
                ...item,
                label:item.value})
                ));
            setRegionList(codeList.reg_list.map((item,index)=>({
                ...item,
                label:item.full_nm})
                ));
        }
    },[codeList])

    return (
        <CommonMainWrap style={{margin:0}}>
            <CommonSubBox style={{justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="is_ing-label"
                            defaultValue={''}
                            name="status"
                            onChange={(e)=>setSearchStatus(e.target.value)}
                        >
                            <FormControlLabel value={''} control={<Radio />} label={`전체 (${list && list.length})`} />
                            <FormControlLabel value={'R'} control={<Radio />} label={`준비 (${list && list.filter((item)=>item.pro_st==='R').length})`} />
                            <FormControlLabel value={'I'} control={<Radio />} label={`촬영 (${list && list.filter((item)=>item.pro_st==='I').length})`} />
                            <FormControlLabel value={'S'} control={<Radio />} label={`진행 (${list && list.filter((item)=>item.pro_st==='S').length})`} />
                            <FormControlLabel value={'E'} control={<Radio />} label={`완료 (${list && list.filter((item)=>item.pro_st==='E').length})`} />
                        </RadioGroup>
                    </FormControl>
                    <TextField
                            id='pnm'
                            label='과업명'
                            size='small'
                            value={searchPnm}
                            onChange={(e)=>setSearchPnm(e.target.value)}
                        />
                    <TextField
                            id='alias'
                            label='업체명'
                            size='small'
                            value={searchAlias}
                            onChange={(e)=>setSearchAlias(e.target.value)}
                        />
                </div>
                <Button variant="contained" style={{width:'15rem'}} onClick={()=>setNewModal(true)}>과업 등록</Button>
            </CommonSubBox>
            {/* <CommonGridBox>

                <CommonDataGrid
                        isLoading={isLoading}
                        list={projectList}
                        columns={columns}
                        onRowClick={(e)=>navigate('/project/'+e.row.pno)}
                        hideFooterRowCount={true}
                        rowHeight={42}
                        
                        />
            </CommonGridBox> */}
            <TitleLine>
                <li>
                    <span>과업번호</span>
                    <span>과업명</span>
                    <span>지역</span>
                    <span>용도</span>
                    <span>유형</span>
                    <span />
                    <span style={{width:'100%',textAlign:'right',fontWeight:'normal'}} />
                </li>
                <li>
                    <span>상태</span>
                    <span>업체명</span>
                    <span>시작일</span>
                    <span>종료일</span>
                    <span>제출일</span>
                    <span />
                    <span style={{width:'100%',textAlign:'right',fontWeight:'normal',fontSize:'0.8rem'}}>
                        {queryClient.getQueryData(['REFRESH_TIME'])?
                            moment(queryClient.getQueryData(['REFRESH_TIME']).time).format('yyyy/MM/DD HH:mm:ss')
                            : ''
                        }
                    </span>
                </li>
            </TitleLine>
            <ProjectList>
                {projectList && projectList.map((item,index)=>{
                    return (
                        <ProjectListItem key={index} item={item} codeList={{clientList, regionList, proStList, proKdList, proTpList}}/>
                    )
                })}
            </ProjectList>
            {newModal === true && <NewItem codeList={{clientList, regionList, proStList, proKdList, proTpList}} onClickAway={()=>setNewModal(false)}/>}
        </CommonMainWrap>
    );

}

const ProjectListItem = ({item, codeList}) => {

    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [target, setTarget] = useState(undefined);
    const [anchorEl, setAnchorEl] = useState(null);

    const {clientList, regionList, proStList, proKdList, proTpList} = codeList;

    const {mutate} = useSetProject();

    useEffect(()=>{
        setTarget(item)
    },[item])

    const handleUpdateClick = useCallback((updateItem) => {
        const temp = {
            mode: 'PUT',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = (updateItem) => {
        queryClient.setQueryData(
            [MODAL_QUERY_NM],
            {
                show:true,
                msg:'삭제하시겠습니까?',
                height:'20vh',
                okButton:()=>confirmDelete(updateItem)
            }
        )
    }

    const confirmDelete = useCallback((updateItem) => {
        const temp = {
            mode: 'DELETE',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAutoValueChange = (id,val1,id2,val2) => {
        const temp  = {...target,[id]:val1,[id2]:val2}
        setTarget(temp);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'status-popper' : undefined;
    const handleStatusClick = (e) => {
        setAnchorEl(anchorEl?null:e.currentTarget);
    }

    return target && (
        <li>
            <div className="box">
                <span onClick={()=>navigate('/project/'+target.pno)}>{target && target.pno}</span>
                <div aria-describedby={id} onClick={handleStatusClick}>
                    <ProjectStatusLabel status={target.pro_st} value={target.pro_st_nm} />
                </div>
                <Popper id={id} open={open} anchorEl={anchorEl}>
                    <StatusChangePopper pid={target.pid} proStList={proStList} onClickAway={handleStatusClick}/>
                </Popper>
            </div>
            <div className="box">
                <TextField
                    id='pnm'
                    size="small"
                    style={{width:'100%'}} 
                    value={target && target.pnm}
                    onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                />
                <Autocomplete
                    id="cid"
                    size='small'
                    options={clientList}
                    value={(target && target.cname) && target.cname}
                    renderInput={(params) => <TextField {...params} />}
                    onChange={(e,v)=>(v!==null)&&handleAutoValueChange('cid',v.cid,'cname',v.cname)}
                />
            </div>
            <div className="box">
                <Autocomplete
                    id="reg_cd"
                    size='small'
                    options={regionList}
                    value={(target && target.reg_cd_nm) && target.reg_cd_nm}
                    renderInput={(params) => <TextField {...params} />}
                    onChange={(e,v)=>(v!==null)&&handleAutoValueChange('reg_cd',v.reg_cd,'reg_cd_nm',v.full_nm)}
                />
                <DesktopDatePicker
                    id='sdate'
                    format='YYYY-MM-DD'
                    size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={target && moment(target.sdate)}
                    onChange={(value)=>handleValueChange('sdate', value.format('YYYY-MM-DD'))}
                />
            </div>
            <div className="box">
                <Autocomplete
                    id="pro_kd"
                    size='small'
                    options={proKdList}
                    value={(target && target.pro_kd_nm) && target.pro_kd_nm}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={(e,v)=>(v!==null)&&handleAutoValueChange('pro_kd',v.code,'pro_kd_nm',v.value)}
                />
                <DesktopDatePicker
                    id='edate'
                    format='YYYY-MM-DD'
                    size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={target && moment(target.edate)}
                    onChange={(value)=>handleValueChange('edate', value.format('YYYY-MM-DD'))}
                />
            </div>
            <div className="box">
                <Autocomplete
                    id="pro_tp"
                    size='small'
                    options={proTpList}
                    value={(target && target.pro_tp_nm) && target.pro_tp_nm}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={(e,v)=>(v!==null)&&handleAutoValueChange('pro_tp',v.code,'pro_tp_nm',v.value)}
                />
                <DesktopDatePicker
                    id='odate'
                    format='YYYY-MM-DD'
                    size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={target && moment(target.odate)}
                    onChange={(value)=>handleValueChange('odate', value.format('YYYY-MM-DD'))}
                />
            </div>
            <div className="box">
                <Button variant="contained" onClick={()=>handleUpdateClick(target)}>수정</Button>
                <Button variant="contained" onClick={()=>handleDeleteClick(target)}>삭제</Button>
            </div>
        </li>
    )

}

const PopperWrapper = styled.div`
    border: 1px solid red;
    margin-top: 0.2rem;
    width: 8rem;
    background: #ffffff;
    border-radius: 8px;
    border: 1.5px solid ${theme.color.black[40]};
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    gap:0.25rem;
`;

const StatusChangePopper = ({pid, proStList, onClickAway}) => {

    const queryClient = useQueryClient();
    const {mutate} = useSetProjectStatus();

    const handleUpdateClick = useCallback((updateItem) => {
        mutate(
            updateItem,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                    onClickAway();
                }
            }
            )
    })

    return (
        <ClickAwayListener onClickAway={onClickAway}>
            <PopperWrapper>
                {proStList && proStList.map((item,index)=>{
                    return (
                        <div onClick={()=>handleUpdateClick({pid,pro_st:item.code})}>
                            <ProjectStatusLabel key={index} status={item.code} value={item.value} />
                        </div>
                    )
                })}
            </PopperWrapper>
        </ClickAwayListener>
    )
}

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 65rem;
    height: 15rem;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const NewItem = ({codeList, onClickAway}) => {

    const queryClient = useQueryClient();

    const {clientList, regionList, proStList, proKdList, proTpList} = codeList;

    const [target, setTarget] = useState();

    const {mutate} = useSetProject();

    const handleUpdateClick = useCallback((updateItem) => {
        const temp = {
            mode: 'POST',
            ...updateItem,
            oid:1,
            pro_st: 'R'
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'등록하였습니다.',
                            height:'20vh',
                        }
                    )
                    onClickAway(false);
                }
            }
            )
    })
    

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAutoValueChange = (id,val1,id2,val2) => {
        const temp  = {...target,[id]:val1,[id2]:val2}
        setTarget(temp);
    }
    return (
        
            <CommonModalWrap style={{zIndex:1300}}>
                {/* <ClickAwayListener onClickAway={onClickAway}> */}
                    <DetailWindow>
                        <CommonModalBar title={'과업 등록'} close={onClickAway}/>
                        <ProjectList>
                            <li>
                                <div className="box" />
                                <div className="box">
                                    <TextField
                                        id='pnm'
                                        label='과업명'
                                        size="small"
                                        style={{width:'100%'}} 
                                        value={target && target.pnm}
                                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                                    />
                                    <Autocomplete
                                        id="cid"
                                        size='small'
                                        options={clientList}
                                        value={(target && target.cname) && target.cname}
                                        renderInput={(params) => <TextField {...params} label='업체명'/>}
                                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('cid',v.cid,'cname',v.cname)}
                                    />
                                </div>
                                <div className="box">
                                    <Autocomplete
                                        id="reg_cd"
                                        size='small'
                                        options={regionList}
                                        value={(target && target.reg_cd_nm) && target.reg_cd_nm}
                                        renderInput={(params) => <TextField {...params} label='지역' />}
                                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('reg_cd',v.reg_cd,'reg_cd_nm',v.full_nm)}
                                    />
                                    <DesktopDatePicker
                                        id='sdate'
                                        label='시작일'
                                        format='YYYY-MM-DD'
                                        size='small'
                                        slotProps={{ textField: { size: 'small'} }}
                                        value={(target && target.sdate) && moment(target.sdate)}
                                        onChange={(value)=>handleValueChange('sdate', value.format('YYYY-MM-DD'))}
                                    />
                                </div>
                                <div className="box">
                                    <Autocomplete
                                        id="pro_kd"
                                        size='small'
                                        options={proKdList}
                                        value={(target && target.pro_kd_nm) && target.pro_kd_nm}
                                        renderInput={(params) => <TextField {...params} label='용도'/>}
                                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('pro_kd',v.code,'pro_kd_nm',v.value)}
                                    />
                                    <DesktopDatePicker
                                        id='edate'
                                        label='종료일'
                                        format='YYYY-MM-DD'
                                        size='small'
                                        slotProps={{ textField: { size: 'small'} }}
                                        value={(target && target.edate) && moment(target.edate)}
                                        onChange={(value)=>handleValueChange('edate', value.format('YYYY-MM-DD'))}
                                    />
                                </div>
                                <div className="box">
                                    <Autocomplete
                                        id="pro_tp"
                                        size='small'
                                        options={proTpList}
                                        value={(target && target.pro_tp_nm) && target.pro_tp_nm}
                                        renderInput={(params) => <TextField {...params}  label='유형'/>}
                                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('pro_tp',v.code,'pro_tp_nm',v.value)}
                                    />
                                    <DesktopDatePicker
                                        id='odate'
                                        label='제출일'
                                        format='YYYY-MM-DD'
                                        size='small'
                                        slotProps={{ textField: { size: 'small'} }}
                                        value={(target && target.odate) && moment(target.odate)}
                                        onChange={(value)=>handleValueChange('odate', value.format('YYYY-MM-DD'))}
                                    />
                                </div>
                            </li>
                        </ProjectList>
                        <div style={{display:'flex',justifyContent:'flex-end',alignItems:'flex-end',height:'3rem'}}>
                            <Button variant='contained' onClick={()=>handleUpdateClick(target)}>등록</Button>
                        </div>
                    </DetailWindow>
                {/* </ClickAwayListener> */}
            </CommonModalWrap>
    )
}
export default Project;